module.exports = __webpack_public_path__ + "static/media/main_06.2e78124b.png";